import React, { FunctionComponent } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Box, constants, OptionProps, Select } from '@match/react-component-library';

const { SPACE } = constants;

interface OperatingSystemDropdownProps {
  operatingSystemChoices: string[];
  onOperatingSystemSelect: (selection?: OptionProps<{}> | undefined) => void;
}

export const OperatingSystemDropdown: FunctionComponent<OperatingSystemDropdownProps> = ({
  operatingSystemChoices,
  onOperatingSystemSelect,
}) => {
  const intl = useIntl();

  return (
    <Box marginBottom={SPACE.XLARGE}>
      <Box marginBottom={SPACE.SMALL}>
        <FormattedMessage {...messages.operatingSystem} />
      </Box>
      <Select
        buttonAriaLabelClear={intl.formatMessage(messages.selectAriaClear)}
        buttonAriaLabelDownArrow={intl.formatMessage(messages.selectAriaDown)}
        buttonAriaLabelUpArrow={intl.formatMessage(messages.selectAriaUp)}
        id="operatingSystemSelect"
        isCombobox
        name="operatingSystemSelect"
        onSelect={onOperatingSystemSelect}
        placeholder={intl.formatMessage(messages.selectOperatingSystem)}
      >
        {operatingSystemChoices.map((operatingSystem: string) => {
          return (
            <Select.Option key={operatingSystem} value={operatingSystem}>
              {operatingSystem}
            </Select.Option>
          );
        })}
      </Select>
    </Box>
  );
};

const messages = defineMessages({
  operatingSystem: {
    id:
      'src/modules/pages/ContactUsPage/ContactUsSC3/OperatingSystemDropdown/OperatingSystemDropdown:operatingSystem',
    description: 'operating System section header',
    defaultMessage: 'Operating System',
  },
  selectAriaUp: {
    id:
      'src/modules/pages/ContactUsPage/ContactUsSC3/OperatingSystemDropdown/OperatingSystemDropdown:selectAriaUp',
    description: 'up text',
    defaultMessage: 'up',
  },
  selectAriaDown: {
    id:
      'src/modules/pages/ContactUsPage/ContactUsSC3/OperatingSystemDropdown/OperatingSystemDropdown:selectAriaDown',
    description: 'down text',
    defaultMessage: 'down',
  },
  selectAriaClear: {
    id:
      'src/modules/pages/ContactUsPage/ContactUsSC3/OperatingSystemDropdown/OperatingSystemDropdown:selectAriaClear',
    description: 'clear text',
    defaultMessage: 'clear',
  },
  selectOperatingSystem: {
    id:
      'src/modules/pages/ContactUsPage/ContactUsSC3/OperatingSystemDropdown/OperatingSystemDropdown:selectOperatingSystem',
    description: 'select operating system dropdown placeholder',
    defaultMessage: 'Select Operating System',
  },
});
